import CashFlow from './cashFlow';
import ComingNomenclature from './comingNomenclature';
import ComingNomenclatureAdjustment from './comingNomenclatureAdjustment';
import ConsumptionNomenclature from './consumptionNomenclature';
import Contractors from './contractor';
import ContractorIndividual from './contractorIndividual';
import ContractorLegal from './contractorLegal';
import ContractorObject from './contractorObject';
import DriverMixerAdjustments from './driverMixerAdjustments';
import DriverSalaryAdjustments from './driverSalaryAdjustments';
import DriverTransport from './driverTransport';
import Employee from './employee';
import EmployeeSalaryAdjustments from './employeeSalaryAdjustments';
import Factory from './factory';
import Login from './login';
import Material from './materials';
import Nomenclature from './nomenclature';
import NomenclatureCustomName from './nomenclatureCustomName';
import Report from './report';
import Request from './request';
import Role from './roles';
import Shift from './shift';
import TemplateSalary from './templateSalary';
import Transport from './transport';
import TransportBrand from './transportBrand';

export const ApiRole = new Role();
export const ApiMaterial = new Material();
export const ApiTemplateSalary = new TemplateSalary();
export const ApiNomenclature = new Nomenclature();
export const ApiEmployee = new Employee();
export const ApiContractorLegal = new ContractorLegal();
export const ApiContractorIndividual = new ContractorIndividual();
export const ApiTransport = new Transport();
export const ApiContractors = new Contractors();
export const ApiContractorObject = new ContractorObject();
export const ApiLogin = new Login();
export const ApiRequest = new Request();
export const ApiShift = new Shift();
export const ApiTransportBrand = new TransportBrand();
export const ApiReport = new Report();
export const ApiFactory = new Factory();
export const ApiComingNomenclature = new ComingNomenclature();
export const ApiConsumptionNomenclature = new ConsumptionNomenclature();
export const ApiDriverTransport = new DriverTransport();
export const ApiCashFlow = new CashFlow();
export const ApiComingNomenclatureAdjustment = new ComingNomenclatureAdjustment();
export const ApiDriverSalaryAdjustments = new DriverSalaryAdjustments();
export const ApiNomenclatureCustomName = new NomenclatureCustomName();
export const ApiDriverMixerAdjustments = new DriverMixerAdjustments();
export const ApiEmployeeSalaryAdjustments = new EmployeeSalaryAdjustments();
